import { render, staticRenderFns } from "./BundleSetEdit.vue?vue&type=template&id=525bc425&"
import script from "./BundleSetEdit.vue?vue&type=script&lang=js&"
export * from "./BundleSetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports